/* eslint-disable react/prop-types */
import { React } from 'react';

import { Message } from 'semantic-ui-react';

// eslint-disable-next-line arrow-body-style
const DisplayErrorString = ({ errorMessage }) => {
  return (
    <>
      {errorMessage && (
        <Message negative>
          <Message.Header>Erreur !!!</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}
    </>
  );
};
export default DisplayErrorString;
